const actions = {
  SET_PENDING_TO_TRUE: 'SET_PENDING_TO_TRUE',
  SET_PENDING_TO_FALSE: 'SET_PENDING_TO_FALSE',

  setPendingToTrue: () => ({
    type: actions.SET_PENDING_TO_TRUE,
  }),

  setPendingToFalse: () => ({
    type: actions.SET_PENDING_TO_FALSE,
  }),
};

export default actions;
